module.exports = __webpack_public_path__ + "static/media/3.a714d38a.jpg";